module.exports = __webpack_public_path__ + "static/media/trusted-IITJ.16bb4b4d.png";